import { memoize } from "lodash";
import { observable } from "mobx";

class ReportDetailVisibleByIDStore {
  reportID: number;
  isDetailVisible = observable.box<boolean>(false);
  constructor(reportID: any) {
    this.reportID = reportID;
  }
}

export const getReportDetailVisibleByIDStore = memoize(
  (reportID) => {
    return new ReportDetailVisibleByIDStore(reportID);
  },
  (reportID: number) => reportID
);
export default getReportDetailVisibleByIDStore;
